import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_NAME = 'TaxPro - Answers';
const DEFAULT_OG_IMAGE = 'https://images.unsplash.com/photo-1772290137750-101578a38881?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBnbGFzcyUyMGJsdWUlMjBncmVlbnxlbnwwfHx8fDE3NzYzMDI4MzF8MA&ixlib=rb-4.1.0&q=85';

function setMeta(name, content, attr = 'name') {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.content = content || '';
}

export function useSEO({ title, description, image }) {
  const location = useLocation();
  const baseUrl = window.location.origin;

  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    document.title = fullTitle;

    // Standard meta
    setMeta('description', description);

    // Open Graph
    setMeta('og:title', fullTitle, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:image', image || DEFAULT_OG_IMAGE, 'property');
    setMeta('og:url', `${baseUrl}${location.pathname}`, 'property');
    setMeta('og:type', 'website', 'property');
    setMeta('og:site_name', SITE_NAME, 'property');

    // Twitter Card
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);
    setMeta('twitter:image', image || DEFAULT_OG_IMAGE);
  }, [title, description, image, location.pathname, baseUrl]);
}
